import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';

import { UserSessionStoreService as StoreService } from '../store/user-session-store.service';
import { Router } from '@angular/router';


export const AuthTokenSkipHeader = 'X-Skip-Auth-Token';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private readonly store: StoreService,
    private readonly router: Router,
  ) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (!req.url.includes('api/appointment/getAppointmentLink') && !req.url.includes('api/appointment/updateAppointmentStatusB64')) {
      if ((req.headers && req.headers.has(AuthTokenSkipHeader)) || req.url.includes('i18n/')) {
        const headers = req.headers.delete(AuthTokenSkipHeader);
        return next.handle(req.clone({ headers }));
      }
      const authToken = this.store.getAccessToken();
      if (authToken) {
        return next.handle(this.accessauthToken(authToken, req));
      } else {
        if (this.router.url !== '/' && this.router.url !== '/login') {
          this.router.navigate(['/']);
        }
      }
      return throwError('Request forbidden ! No access token available.');
    } else {
      return next.handle(
        req.clone({
          setHeaders: {
            'Content-Type': 'application/json',
          },
        }),
      );
    }
  }
  accessauthToken(authToken, req) {
    if (
      req.url.includes('api/appointment') ||
      req.url.includes('api/onlineAppointment')
    ) {
      req = req.clone({
        setHeaders: {
          authorization: `Bearer ${authToken}`,
        },
      });
    } else {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${authToken}`,
        },
      });
    }
    return req;
  }
}
